// Minimal bilingual layer: the SAME components render for RO and RU,
// with strings chosen by the active language from a context.
// /ru/* routes wrap the normal pages in <LangContext.Provider value="ru">.

import { createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';

export const LangContext = createContext('ro');

export const useLang = () => useContext(LangContext);

// tr('text român', 'текст на русском') — picks by the active language.
export const tr = (lang, ro, ru) => (lang === 'ru' ? ru : ro);

export const useTr = () => {
    const lang = useLang();
    return (ro, ru) => tr(lang, ro, ru);
};

// Language from the URL path — for the chrome (Navbar/Footer) that
// renders OUTSIDE the route elements and never sees the RU context.
export const usePathLang = () => {
    const { pathname } = useLocation();
    return pathname.startsWith('/ru') ? 'ru' : 'ro';
};
